module.exports = __webpack_public_path__ + "img/detail-bg.d8dfb11b.png";